__webpack_require__.p = "https://vri.linguisticainternational.com/";